<template>
  <div class="nav-container">
    <v-btn class="nav-btn" text depressed @click="toTarget" :color="color">
      <v-icon v-if="icon">{{icon}}</v-icon>
      <div :class="navClass">{{ title }}</div>
    </v-btn>
  </div>
</template>
<script>
export default {
  methods: {
    toTarget () {
      console.log('nav this.$router', this.$router)
      this.$router.push({
        path: this.to
      }).catch(() => {
        console.log('catch this.$router', this.$router)
      })
      if (this.$router.history.current.query.to) {
        this.$nextTick(() => window.document.querySelector('#' + this.$router.history.current.query.to).scrollIntoView())
      }
    }
  },
  props: {
    navClass: {
      default: 'header-nav-item',
      type: String
    },
    color: {
      default: 'black',
      type: String
    },
    icon: {
      default: '',
      type: String
    },
    title: {
      default: 'item',
      type: String
    },
    to: {
      default: '/',
      type: String
    }
  }
}
</script>
<style scoped>
  .nav-container{
    height: 100%;
    display: flex;
  }
  .header-nav-item{
    font-size: 2.5rem;
    font-family: Source Han Sans HK;
    font-style: normal;
    font-weight: bold;
  }
  .nav-btn{
    align-self: flex-end;
    margin-bottom: 1.5rem;
  }
  .nav-btn::before {
    background-color: transparent !important;
  }
</style>
